import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { OnRouteResolve } from '@frontend/sports/common/core/utils/hooks';
import { TimerService } from '@frontend/sports/common/core/utils/timer';
import { HtmlNode, WINDOW } from '@frontend/vanilla/core';

import { PrintCallbackMessage, PrintCallbackType, PrintDeviceType } from './print.models';

@Component({
    template: '',
    standalone: false,
})
export abstract class PrintPageBaseComponent<TModel> extends OnRouteResolve<TModel> implements AfterViewInit {
    hasErrors?: boolean;
    private readonly _window = inject(WINDOW);
    private readonly _doc = inject(DOCUMENT);

    printCommand: PrintDeviceType;

    constructor(
        route: ActivatedRoute,
        private htmlNodeService: HtmlNode,
        private timer: TimerService,
    ) {
        super(route);
        this.printCommand = (this.route.snapshot.queryParamMap?.get('device') as PrintDeviceType) || PrintDeviceType.Default;
    }

    ngAfterViewInit(): void {
        if (this.hasErrors) {
            this._window.parent.postMessage(<PrintCallbackMessage>{ type: PrintCallbackType.DataLoadingError }, '*');
        } else {
            this.htmlNodeService.setCssClass('card-content', true);
            if (this.printCommand !== PrintDeviceType.Default) {
                //handling print in wrapperApp by triggering CCB event
                this._window.parent.postMessage(<PrintCallbackMessage>{ type: PrintCallbackType.PrintReadyForWrapper }, '*');
            } else {
                this.triggerDefaultPrint();
            }
        }
    }

    private triggerDefaultPrint(): void {
        this._window.onafterprint = () => {
            this._window.parent.postMessage(<PrintCallbackMessage>{ type: PrintCallbackType.PrintFinished }, '*');
        };

        this._window.parent.postMessage(<PrintCallbackMessage>{ type: PrintCallbackType.PrintStarted }, '*');
        const executePrint = () => {
            try {
                if (!this._doc.execCommand('print', false)) {
                    this.timer.setTimeout(() => this._window.print(), 2000);
                }
            } catch {
                this._window.print();
            }
        };

        executePrint();
    }
}
